<template>
  <v-row>
    <v-col cols="12" md="6" sm="7">
      <v-card class="card-block">
      <h3>Export Meter Data</h3>

      <div v-if="exportEndpoint.complete" class="select-block">
        <v-alert
          outlined
          type="success"
          text
        >
          <div>
            Your report will be available in your downloads section shortly
          </div>
          <div style="margin-top: 10px;">
            <v-btn
              @click="resetExport"
              class="ma-2"
              color="green"  role="link">
              Run Further Export
            </v-btn>
          </div>
        </v-alert>
      </div>

      <div v-if="!exportEndpoint.complete" class="select-block">
        <date-range-picker
          ref="exportEndpoint"
          :locale-data="{
                      firstDay: 1,
                      format: 'DD-MM-YYYY HH:mm:ss'
                    }"
          v-model="exportEndpoint.dateRange"
          :auto-apply="true"
        >
          <div
            slot="input"
            slot-scope="exportEndpoint"
            style="min-width: 350px;"
          >
                      <span v-if="!exportEndpoint.startDate"
                      >Click to choose date range</span
                      >
            <span v-if="exportEndpoint.startDate"
            >{{ exportEndpoint.startDate | dateFormat('DD/MM/YYYY') }} -
                        {{ exportEndpoint.endDate | dateFormat('DD/MM/YYYY') }}</span
            >
          </div>
        </date-range-picker>

        <v-row >
          <v-col cols="8">
        <v-radio-group
          v-model="exportEndpoint.allReads"
          row
        >
          <v-radio
            :key="i"
            v-for="(item, i) in exportEndpoint.readTypeOptions"
            :label="item.name"
            :value=i
          ></v-radio>
        </v-radio-group>
          </v-col>
        </v-row>

        <v-switch
          v-if="units.length > 1"
          v-model="exportEndpoint.allUnits"
          color="secondary"
          label="All units"
        ></v-switch>

        <v-combobox
          v-if="!exportEndpoint.allUnits"
          v-model="exportEndpoint.selectedUnits"
          :items="units"
          label="Select Units"
          multiple
          outlined
          dense
        ></v-combobox>

        <div style="margin-top: 10px;">
          <v-btn
            v-if="exportEndpoint.dateRange.startDate"
            @click="exportMeters"
            class="ma-2"
            color="green"  role="link">
            Export
          </v-btn>
        </div>
      </div>
      </v-card>
    </v-col>

  </v-row>
</template>

<script>
import Vue from "vue";

import DateRangePicker from "vue2-daterange-picker";

import {date} from "@/mixins/date";

Vue.component("DateRangePicker", DateRangePicker);
export default {
  name: "ExportEndpointData",
  mixins: [
    date
  ],
  props: {
    id: {
      type: String,
      required: true
    },
    units: {
      type: Array,
      required: true
    }
  },
  computed: {
    unitValues() {
      return [...new Set(this.exportEndpoint.selectedUnits.map(item => item.value))];
    }
  },
  data: () => ({
    complete: false,
    select: [],
    exportEndpoint: {
      startDate: "",
      endDate: "",
      dateRange: {},
      loading: false,
      complete: false,
      allReads: 0,
      readTypeOptions: [
        { item: 0, name: 'One read per day' },
        { item: 1, name: 'All reads' }
      ],
      allUnits: true,
      selectedUnits: [],
      availableUnits: []
    }
  }),
  methods: {
    resetExport() {
      this.exportEndpoint.selectedUnits = [];
      this.exportEndpoint.startDate = "";
      this.exportEndpoint.endDate = "";
      this.exportEndpoint.dateRange.startDate = null;
      this.exportEndpoint.dateRange.endDate = null;
      this.exportEndpoint.loading = false;
      this.exportEndpoint.complete = false;
      this.exportEndpoint.allReads = 0;
      this.exportEndpoint.allUnits = true;
    },
    async exportMeters() {
      const endpointRef = this.id;
      let from = this.exportEndpoint.dateRange.startDate;
      let to = this.exportEndpoint.dateRange.endDate;
      const allReads = this.exportEndpoint.allReads;
      const selectedUnits = this.unitValues;
      const allUnits = this.exportEndpoint.allUnits;

      if (!from || !to) {
        await this.$store.dispatch("notification/triggerError", { detail: "Please select at lease one bill or credit" });
        return;
      }

      from = this.formatDate(from);
      to = this.formatDate(to);

      await this.$store.dispatch("loader/loaderInitiate", { title: "Requesting Download" });

      const isSuccess = await this.$store.dispatch("downloads/requestMeterData", {endpointRef, from, to, allReads, selectedUnits, allUnits});

      if (isSuccess) {
        this.exportEndpoint.complete = true;
        await this.$store.dispatch("notification/triggerSuccess", { detail: "Your file will be available from your downloads page shortly", title: "Download requested" });
      }

      await this.$store.dispatch("loader/loaderCancel");
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  text-align: left;
  margin-bottom: 20px;
}

.select-block {
  text-align: left;
}

.card-block {
  padding: 30px;
}
</style>
